import {
  Network,
  Code2,
  ShieldAlert,
  ShieldCheck,
  Zap,
  Server,
  Box,
  BarChart3, 
  Globe,     
} from "lucide-react";

export const capabilities = [
  {
    title: "Security Operations & Detection Engineering",
    icon: ShieldAlert,
    color: "cyan",
    metric: "MTTD ↓ 45m → 8m",
    bullets: [
      "SIEM monitoring, alert triage, and incident investigation",
      "Wazuh rule tuning and detection quality improvement",
      "FortiAnalyzer log analysis and event correlation",
      "MITRE ATT&CK mapping for structured detection",
    ],
    tags: ["Wazuh", "FortiAnalyzer", "MITRE"],
  },
  {
    title: "Security Automation & Orchestration",
    icon: Zap,
    color: "green",
    metric: "Manual Work ↓ Significant",
    bullets: [
      "PowerShell and Python automation for security operations",
      "SOAR-style workflows for alert enrichment",
      "Threaded pipelines for distributed systems",
      "Bulk automation across endpoints and devices",
    ],
    tags: ["Python", "PowerShell", "Flask"],
  },
  {
    title: "Endpoint Security & Hardening",
    icon: ShieldCheck,
    color: "emerald",
    metric: "Baseline Enforcement ↑",
    bullets: [
      "CIS benchmark alignment and endpoint hardening",
      "GPO-based enforcement across enterprise",
      "Patch, AV, encryption, and service validation",
      "Legacy OS remediation and modernization",
    ],
    tags: ["CIS", "GPO", "Windows Security"],
  },
  {
    title: "Risk Analysis & Audit Reporting",
    icon: BarChart3,
    color: "amber",
    metric: "Audit-Ready Reporting",
    bullets: [
      "Endpoint risk scoring and exposure analysis",
      "Audit-ready reporting across branches",
      "MITRE-based reasoning for remediation",
      "Security posture visualization",
    ],
    tags: ["Risk Scoring", "Audit", "Compliance"],
  },
  {
    title: "Enterprise Operations & Branch Security",
    icon: Globe,
    color: "teal",
    metric: "125+ Branch Coverage",
    bullets: [
      "Security operations across distributed branches",
      "Standardization of endpoint and network controls",
      "Operational visibility at scale",
      "Audit readiness and remediation tracking",
    ],
    tags: ["Enterprise", "Branch Ops"],
  },
  {
    title: "Network Security & Perimeter Control",
    icon: Network,
    color: "amber",
    metric: "Policy & Traffic Control",
    bullets: [
      "FortiGate firewall policy review",
      "Traffic flow and segmentation analysis",
      "Interface and address object validation",
      "Perimeter hardening",
    ],
    tags: ["FortiGate", "Firewall"],
  },
  {
    title: "Identity & Infrastructure Engineering",
    icon: Server,
    color: "blue",
    metric: "125+ Branch Migration",
    bullets: [
      "Active Directory migration at scale",
      "Workgroup to domain transition",
      "Post-deployment automation",
      "User environment restoration",
    ],
    tags: ["AD", "GPO", "Windows Server"],
  },
  {
    title: "Security Tooling & Full-Stack Development",
    icon: Box,
    color: "violet",
    metric: "Internal Platforms Built",
    bullets: [
      "React + Python security platforms",
      "Risk dashboards and audit systems",
      "Backend pipelines and APIs",
      "Security-first architecture",
    ],
    tags: ["React", "Flask", "APIs"],
  },
  {
    title: "AppSec & Vulnerability Assessment",
    icon: Code2,
    color: "red",
    metric: "Critical Issues Resolved",
    bullets: [
      "OWASP Top 10 vulnerability analysis",
      "Manual and AI-assisted code review",
      "Penetration testing approaches",
      "Remediation validation",
    ],
    tags: ["OWASP", "VAPT"],
  },
];